import React from 'react' 

const Test = () => (
<div>hello!</div>
)


export default Test